import React from 'react'
import {Helmet} from "react-helmet"
import { useStaticQuery, graphql } from "gatsby"

export default props => {
    const data = useStaticQuery(graphql`
        query  {
            contentfulSeo(title: {eq: "Orienteed"}) {
                title
                lang
                attributes {
                    name
                    property
                    content
                }
            }
            allContentfulAsset(filter: {contentful_id: {eq: "6QzKXWLZ5cpZZMN2WCRGwH"}}) {
                edges {
                  node {
                    contentful_id
                    file {
                        url
                    }
                  }
                }
            }
        }
    `)

    let keys = '';
    let desc = '';
    for(let attr in data.contentfulSeo.attributes) {
        switch(data.contentfulSeo.attributes[attr].name) {
            case 'keywords':
                keys = data.contentfulSeo.attributes[attr].content
                break
            case 'description':
                desc = data.contentfulSeo.attributes[attr].content
                break
            default:                
        }
    }

    const title = props.title || data.contentfulSeo.title 
    const lang  = props.lang || data.contentfulSeo.lang    
    const keywords = props.keywords || keys    
    const description = props.description || desc
    const schemaType = props.schemaType || ''
    const uri = (`${process.env.GATSBY_DOMAIN}${lang}/${ props.slug !== undefined ? props.slug : '' }`).toLowerCase().trim()
    const logotipo = data.allContentfulAsset.edges[0].node.file.url
    const image = props.image || data.allContentfulAsset.edges[0].node.file.url
    const robotsValue = `${ process.env.GATSBY_DISABLEROBOTS}` === 'true' ? 'noindex' : 'index,follow'

    return (
        <Helmet
          title={data.contentfulSeo.title}
          titleTemplate={`${title} | %s`}
        >
            <html lang={lang} />
            <meta name="description" content={description || title} />
            <meta name="robots" content={robotsValue} />
            <meta name="author" content="Orienteed" />
            <meta name="keywords" content={keywords} />

            <meta property="og:type" content="website" />
            <meta property="og:site_name" content="Orienteed" />
            <meta property="og:url" content={uri} />
            <meta property="og:title" content={`${title} | Orienteed`} />
            <meta property="og:description" content={description || title} />
            <meta property="og:image" content={`https:${image}`} />
            <meta property="og:locale" content={lang} />

            <meta name="twitter:card" content="summary_large_image"/>
            <meta name="twitter:image" content={`https:${image}`}/>
            <meta name="twitter:site" content="@orienteed"/>
            <meta name="twitter:creator" content="@orienteed"/> 
            <meta name="twitter:title" content={`${title} | Orienteed`} /> 
            <meta name="twitter:description" content={description || title} />
            
            <script type="application/ld+json">
                {
                    JSON.stringify({
                        "@context": "http://www.schema.org",
                        "@type": "LocalBusiness",
                        "name": "Orienteed",
                        "legalName": "Orienteed S.L.U.",
                        "email" : "hello@orienteed.com",
                        "url": "https://orienteed.com",
                        "sameAs": [
                            "https://orienteed.com"
                        ],
                        "logo": `https:${logotipo}`,
                        "image": `https:${logotipo}`,
                        "description": "",
                        "address": {
                            "@type": "PostalAddress",
                            "streetAddress": "Cordelería, 32, 15003 A Coruña, C",
                            "addressLocality": "A Coruña",
                            "addressRegion": "A Coruña",
                            "postalCode": "15003",
                            "addressCountry": "España"
                        },
                        "areaServed": {
                            "@type": "geoShape",
                            "addressCountry": "ES"
                        },
                        "geo": {
                            "@type": "GeoCoordinates",
                            "latitude": "43.3701823",
                            "longitude": "-8.4043056"
                        },
                        "hasMap": "",
                        "openingHours": ["Mo-Su 00:00-00:00"],
                        "contactPoint": {
                            "@type": "ContactPoint",
                            "contactType": "Customer Care",
                            "telephone": "+34981914837"
                        },
                        "telephone": "+34981914837"
                    })
                }
            </script>
            { schemaType === "blogpost" &&  
                <script type="application/ld+json">
                    {
                        JSON.stringify({
                            "@context": "https://schema.org", 
                            "@type": "BlogPosting",
                            "headline": title,
                            "image": image,
                            "genre": "ecommerce", 
                            "keywords": keywords,
                            "publisher": {
                                "@type": "Organization",
                                "name": "Orienteed",
                                "logo": `https:${logotipo}`
                            },
                            "url": uri,
                            "dateCreated": new Date(props.createdAt).toLocaleDateString(lang),
                            "datePublished": props.publishDate ? new Date(props.publishDate).toLocaleDateString(lang) : new Date(props.createdAt).toLocaleDateString(lang),
                            "dateModified": new Date(props.updatedAt).toLocaleDateString(lang),
                            "description": description,
                            "author": {
                                "@type": "Person",
                                "name": props.author
                            },
                            "mainEntityOfPage": {
                                "@type": "WebPage"
                            }
                        })
                    }
                </script>            
            }
        </Helmet>
    )
}